import { ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";
export const actionTypes = {
    AUDIT_IMAGE_ITEM_SET: "AUDIT_IMAGE_ITEM_SET",
    AUDIT_IMAGES_SET: "AUDIT_IMAGES_SET",
    AUDIT_IMAGE_ROTATION_PATCH_REQUEST: "AUDIT_IMAGE_ROTATION_PATCH_REQUEST",
    AUDIT_IMAGE_ROTATION_PATCH_REQUEST_SUCCESS:
        "AUDIT_IMAGE_ROTATION_PATCH_REQUEST_SUCCESS",
    AUDIT_IMAGE_ROTATION_PATCH_REQUEST_FAILURE:
        "AUDIT_IMAGE_ROTATION_PATCH_REQUEST_FAILURE",

    AUDIT_IMAGE_ROTATION_POST_REQUEST: "AUDIT_IMAGE_ROTATION_POST_REQUEST",
    AUDIT_IMAGE_ROTATION_POST_REQUEST_SUCCESS:
        "AUDIT_IMAGE_ROTATION_POST_REQUEST_SUCCESS",
    AUDIT_IMAGE_ROTATION_POST_REQUEST_FAILURE:
        "AUDIT_IMAGE_ROTATION_POST_REQUEST_FAILURE"
};

export const actionCreators = {
    itemSet: (auditImage: any) => ({
        type: actionTypes.AUDIT_IMAGE_ITEM_SET,
        payload: { auditImage }
    }),
    set: (auditImages: Array<any>) => ({
        type: actionTypes.AUDIT_IMAGES_SET,
        payload: { auditImages }
    }),
    patchRequest: (auditImage: any) => ({
        type: actionTypes.AUDIT_IMAGE_ROTATION_PATCH_REQUEST,
        payload: { auditImage },
        [WAIT_FOR_ACTION]:
            actionTypes.AUDIT_IMAGE_ROTATION_PATCH_REQUEST_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUDIT_IMAGE_ROTATION_PATCH_REQUEST_FAILURE
    }),
    patchSuccess: (auditImage: any) => ({
        type: actionTypes.AUDIT_IMAGE_ROTATION_PATCH_REQUEST_SUCCESS,
        payload: { auditImage }
    }),
    patchFailure: (error) => ({
        type: actionTypes.AUDIT_IMAGE_ROTATION_PATCH_REQUEST_FAILURE,
        error
    }),

    postRequest: (auditImage: any) => ({
        type: actionTypes.AUDIT_IMAGE_ROTATION_POST_REQUEST,
        payload: { auditImage },
        [WAIT_FOR_ACTION]:
            actionTypes.AUDIT_IMAGE_ROTATION_POST_REQUEST_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUDIT_IMAGE_ROTATION_POST_REQUEST_FAILURE
    }),
    postSuccess: (auditImage: any) => ({
        type: actionTypes.AUDIT_IMAGE_ROTATION_POST_REQUEST_SUCCESS,
        payload: { auditImage }
    }),
    postFailure: (error) => ({
        type: actionTypes.AUDIT_IMAGE_ROTATION_POST_REQUEST_FAILURE,
        error
    })
};

export default {
    create: actionCreators,
    type: actionTypes
};
